<template>
    <div class="table-header">
        <div v-if="!selectedCampaign" class="col-lg-4 col-md-12 table-column header-border">
            <h6 v-text="$t('facebook.ads.campaigns')"/>
        </div>
        <template v-else-if="isCampaign">
            <div class="col-lg-12 col-md-12 table-column">
                <h6 v-if="isAdSet" @click="back()" class="has-cursor" v-text="selectedCampaign.name"/>
                <h6 v-else v-text="selectedCampaign.name"/>
            </div>
            <div class="col-lg-4 col-md-12 table-column header-border" >
                <i class="button--back" @click="back()"><fa icon="chevron-left"/></i>

                <h6 class="breadcrumb-line">
                    <span @click="clear()">{{ $t('facebook.ads.campaigns') }}</span>
                    <span v-if="isAdSet" @click="back()">{{ $t('facebook.ads.adSets') }}</span>
                    {{ $t(isCampaign ? 'facebook.ads.adSets' : 'facebook.ads.ads') }}
                </h6>
            </div>
        </template>

        <div class="col-lg-8 hidden-md hidden-sm hidden-xs">
            <div class="row">
                <div class="col-lg-2 table-column insight-explainer-icon table-col--border-right"
                     v-for="metric in metrics"
                     v-tooltip="metricTooltip(metric)"
                >
                    <i><fa  :icon="metric.icon"/></i>
                    <small class="table-header__text" v-text="$t(`facebook.ads.insights.${metric.metric}`)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'FacebookAdsTableHeader',
    props: {
      status: {
        type: String
      }
    },
    computed: {
      ...mapGetters('facebookAds', {
        metrics: 'getMetrics',
        selected: 'getSelected'
      }),
      selectedCampaign () {
        return this.selected(this.status).campaign
      },
      isCampaign (){
        return !!this.selected(this.status).campaign
      },
      isAdSet (){
        return !!this.selected(this.status).adSet
      },
      isAd (){
        return !!this.selected(this.status).ad
      }
    },
    methods: {
      back () {
        if(this.isAd) {
          this.clear('ad')
        } else if(this.isAdSet) {
          this.clear('adSet')
        } else if(this.isCampaign) {
          this.clear()
        }
      },
      clear(selected = null){
        this.$store.dispatch('facebookAds/resetSelected', {status: this.status, selected})
      },
      metricTooltip (metric) {
        const group = $tc('facebook.ads.campaign', metric.translationSingular ? 1 : 2).toLowerCase()
        return $t(`facebook.ads.insights.explainer.${metric.metric}`, { group })
      }
    }
  }
</script>
